import React from 'react'
import { useSelector } from 'react-redux'

import NewCampaignBudgetAllocationFields from './NewCampaignBudgetAllocationFields'
import NewCampaignImpressionAllocationFields from './NewCampaignImpressionAllocationFields'

import useRightBudgetAndImpressionsCalculation from '../../../../../Multiplatform/UploadAdCreative/useRightBudgetAndImpressionsCalculation'
import useGetAppsData from '../../reusableFields/AppListField/useGetAppsData'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS
} from '../../../../../Multiplatform/Partnerships/RightForms/fields'

const NewCampaignFields = ({ formik }) => {
  const right = useSelector(rightSelector)

  const { allocation_type: rightAllocationType } = right

  const isBudgetAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_BUDGET
  const isImpressionAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS

  const { remainingBudget, remainingImpressions } = useRightBudgetAndImpressionsCalculation()

  useGetAppsData()

  return (
    <>
      {isBudgetAllocationType && (
        <NewCampaignBudgetAllocationFields formik={formik} remainingBudget={remainingBudget} />
      )}
      {isImpressionAllocationType && (
        <NewCampaignImpressionAllocationFields formik={formik} remainingImpressions={remainingImpressions} />
      )}
    </>
  )
}

export default NewCampaignFields
